import { getConfiguration } from './configuration';
import { isAsianHandicap } from './isAsianHandicap';
import { parseHandicap } from './parseHandicap';

export function getToolTipDesc(odd) {
	let tooltip = '';
	
    if (odd.betData) {
    	let tooltipSource = odd.tooltip;
    	if (odd.tooltipByHandicap && odd.tooltipByHandicap['' + odd.betData.handicap]) {
    		tooltipSource = odd.tooltipByHandicap['' + odd.betData.handicap];
    	}
        if (tooltipSource) {
            tooltip = tooltipSource.replaceAll('{{TEAM1}}', odd.team1).replaceAll('{{TEAM2}}', odd.team2);
        } else {
            const dia = odd.betData.dia?.dia ?? null;
            if (dia != null) {
                const betDesc =  `${odd.betData.desc} (${dia})`;
                tooltip = `${betDesc}: ${odd.desc}`;
            }

        }

        if (tooltip.length > 0 && odd.betData.handicap !== '0' && odd.betData.tipoHandicap !== 7) {
            let hcp = odd.betData.handicap;
            if (isAsianHandicap(odd.betData.id) && odd.id === 2) {
                hcp *= -1;
            }
			const conf = getConfiguration();
            const setHandicap = conf.sht || tooltip.indexOf("{{") >= 0 || tooltip.indexOf("@@") >= 0;
            if(setHandicap) {
            	// ho aggiunto questo controllo perche' altrimenti capitavamo nella situazione in cui
            	// sia l'handicap che la traduzione dell'handicap venivano mostrati:
            	// es -> U/O 2.5   usciva   Ci saranno più di 2 goal 2.5
            	// quindi entro in questo if se il cliente vuole da configurazione specificare l'handicap (sht)
            	// oppure se dal cms è stato comunque impostato il marcatore {{Hx}}, potrebbero sempre volerlo specificare
            	// anche in una scommessa specifica
            	
				tooltip = parseHandicap(tooltip, hcp, odd.betData.tipoHandicap, null, odd.betData.dia);
			}

        }
	}
    
	return tooltip;
}
